import {connect} from 'react-redux'
import {
    ActionsRow,
    commons,
    FixedDropDownButton,
    Icon,
    Loader,
    modal,
    utils
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as ciselnikActions from "../../actions/ciselnikActions";
import CiselnikApi from "../../api/gen/cgo/CiselnikApi";
const {sinkEvent} = commons;
import PobockaForm from "../../forms/PobockaForm";
import TablePanel from "../../components/TablePanel";
import CustomCheckbox from "../../components/CustomCheckbox";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

const COLUMN_WIDTH = 3;

/**
 * Stránka administrace - Pobočky
 */
class PobockyPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchPobockyIfNeeded());
    };

    handleCreatePobocka = () => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            PobockaForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.createPobocka(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidatePobocky());
                    dispatch(ciselnikActions.invalidatePobockyNevydejni());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('new_branch'),
            {size: "md"}
        ));
    };

    handleEditPobocka = (pobocka) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            PobockaForm,
            {
                onSubmit: (data) => {
                    // pokud chceme uložit neaktivní pobočku, zkontrolujeme napřed zda ji někdo nemá vybranou jako výchozí
                    if (data.neaktivni) {
                        return CiselnikApi.jePobockaAktivniAVychozi(data.id).then(jeVychozi => {
                            if (jeVychozi) {
                                return new Promise((resolve) => {
                                    this.props.dispatch(modal.ModalActions.showConfirm(
                                        t('used_branch'),
                                        <span>{t('inactive_branch_confirmation',{nazevDat: data.nazev})}</span>,
                                        () => CiselnikApi.updatePobocka(data, data.id).then(() => resolve()),
                                        () => resolve(),
                                        t('save')
                                    ))
                                })
                            } else {
                                return CiselnikApi.updatePobocka(data, data.id);
                            }
                        })
                    } else {
                        return CiselnikApi.updatePobocka(data, data.id);
                    }
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidatePobocky());
                    dispatch(ciselnikActions.invalidatePobockyNevydejni());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: pobocka
            },
            t('branch_change'),
            {size: "md"}
        ));
    };

    renderContextMenu = (pobocka) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(() => {this.handleEditPobocka(pobocka)})}>{t('edit')}</DropdownItem>
        </FixedDropDownButton>
    };

    handleVcetneNeaktivnich = (e) => {
        const {pobockyList} = this.props;
        this.props.dispatch(ciselnikActions.filterPobocky({
            ...pobockyList.filter,
            vcetneNeaktivnich: e.target.checked
        }, false));
    };

    render() {
        const {pobockyList, t} = this.props;
        let content;
        if (pobockyList.fetched) {
            if (pobockyList.rows.length !== 0) {
                content = pobockyList.rows.map(pobocka => {
                    return <CardBody key={pobocka.id} className={pobocka.neaktivni ? "neaktivni" : ""}>
                        <ActionsRow actions={this.renderContextMenu(pobocka)} onClick={sinkEvent((e) => {this.handleEditPobocka(pobocka)})}>
                            <Row>
                                <Col xs={COLUMN_WIDTH}>{pobocka.cisloPobocka}</Col>
                                <Col xs={COLUMN_WIDTH}>{pobocka.nazevPobocka}</Col>
                                <Col xs={COLUMN_WIDTH}>{pobocka.vydejniMisto ? t('yes') : t('no')}</Col>
                                <Col xs={COLUMN_WIDTH}>{pobocka.neaktivni ? t('no') : t('yes')}</Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>;
                });
            } else {
                content = <CardBody><i>{t('no_branch')}</i></CardBody>
            }
        } else {
            content = <Loader/>
        }
        const vcetneNeaktivnich = pobockyList.filter.vcetneNeaktivnich || false;
        return <AdminPage
            title={t('branch_many')}
            subtitle={t('system_operator_branch')}
            content={
                <div>
                    <ButtonToolbar>
                        <Button color="primary" onClick={this.handleCreatePobocka}>Nová</Button>
                        <CustomCheckbox label={t('including_inactive')} value={vcetneNeaktivnich} onChange={this.handleVcetneNeaktivnich}/>
                    </ButtonToolbar>
                    <TablePanel header={
                        <Row>
                            <Col xs={COLUMN_WIDTH}>{t('labels.number')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('labels.name')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('labels.dispensing_place')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('active')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />}
}

function mapStateToProps(state) {
    return {
        pobockyList: utils.storeFromArea(state, ciselnikActions.POBOCKY_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(PobockyPage));
